<template>
  <div id="app">
    <Navbar/>
    <router-view/>
    <Overlay/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Overlay from '@/components/Overlay.vue'
export default {
  name: 'App',
  components: {
    Navbar,
    Overlay
  },
  data: function() {
    return {
      appName: 'Academy',
    }
  },
  // mounted() {
  // },
  methods: {
    // sidebarActive() {
    //   this.sidebar = !this.sidebar
    // },
  }
}
</script>

